import { render } from "./mainCompUpdated.vue?vue&type=template&id=7fbd02d6&scoped=true"
import script from "./mainCompUpdated.vue?vue&type=script&lang=js"
export * from "./mainCompUpdated.vue?vue&type=script&lang=js"

import "./mainCompUpdated.vue?vue&type=style&index=0&id=7fbd02d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbd02d6"]])

export default __exports__